// extracted by mini-css-extract-plugin
export default {"delivery":"Delivery_delivery__2jfHM"};